function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "none",
  d: "M0 0h16v16H0z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M8 1C4.134 1 1 3.902 1 7.481c0 2.04 1.018 3.86 2.609 5.048V15l2.383-1.308c.636.176 1.31.271 2.008.271 3.866 0 7-2.902 7-6.482S11.866 1 8 1zm.696 8.728l-1.783-1.9-3.478 1.9L7.26 5.667l1.826 1.9 3.435-1.9-3.826 4.061z"
}));

var SvgIcMessenger = function SvgIcMessenger(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-messenger.7bdbfd9b.svg";
export { SvgIcMessenger as ReactComponent };